import { AfterViewInit, Component, OnInit } from "@angular/core";
import { CopyShowsViewModel } from "../../../services/show/copy-shows.view-model";
import { NgxSmartModalService } from "ngx-smart-modal";
import { Show } from "../../../domain/show";
import moment from "moment";
import { CalendarDatepickerComponent } from "../calendar-datepicker.component";
import { UserService } from "../../../domain/user-service";
import { Channel } from "../../../domain/channel";

@Component({
  selector: "evrideo-loop-fill-shows",
  templateUrl: "./loop-fill-shows-popup.component.html",
  styleUrls: ["./loop-fill-shows-popup.component.scss"],
})
export class LoopFillShowsPopupComponent implements OnInit {
  private _processing = false;

  public selectedLoopType: LoopType = LoopType.Multiplier;
  public selectedPasteType: PasteType = PasteType.After;
  public selectedMultiplier = 1;
  public get targetStartTime(): moment.Moment {
    if (this.selectedPasteType === PasteType.After) {
      return this.targetStartTimeAfter;
    } else {
      return this.targetStartTimeBefore;
    }
  }
  public targetEndTime?: moment.Moment;
  public targetChannel: Channel;
  public isBlock: boolean;
  public untilNextItemWithPartial: boolean;
  public targetChannelTimezone: string;
  public targetEndTimeDatePicker: CalendarDatepickerComponent;
  public targetStartTimeBefore: moment.Moment;
  public targetStartTimeAfter: moment.Moment;
  public errorMessage: string;
  private _utcOffsetMins: number;
  constructor(
    public _copyShowsViewModel: CopyShowsViewModel,
    private _ngxSmartModalService: NgxSmartModalService,
    private _userService: UserService,
  ) {}

  ngOnInit(): void {
    this._ngxSmartModalService
      .getModal("loopFillShowsPopupModal")
      .onDataAdded.subscribe((data: any) => {
        this.targetChannel = data.targetChannel;
        this.isBlock = data.isBlock;
        this.selectedPasteType = PasteType.After;
        this.targetChannelTimezone = this._userService.getTimezoneValueById(
          this.targetChannel.timezoneId,
        );
        this.targetStartTimeBefore = data.targetStartTimeBefore
          .clone()
          .tz(this.targetChannelTimezone);
        this.targetStartTimeAfter = data.targetStartTimeAfter
          .clone()
          .tz(this.targetChannelTimezone);

        this.targetEndTime = this._copyShowsViewModel.multiplySelectedEndTime(
          1,
          this.targetStartTime,
        );
        this._utcOffsetMins = this.targetEndTime.utcOffset();
        this.resetFields();
      });
  }

  resetFields() {
    this.selectedLoopType = LoopType.Multiplier;
    this.selectedMultiplier = 1;
    this.untilNextItemWithPartial = false;
    this.errorMessage = null;
  }

  applyClicked() {
    if (!this._processing) {
      this._processing = true;

      this.errorMessage = null;
      if (this.selectedLoopType === LoopType.UntilNextItem) {
        this._copyShowsViewModel
          .pasteUntilNextItem(
            this.targetStartTime,
            this.targetChannel,
            this.isBlock,
            this.untilNextItemWithPartial,
          )
          .then(() => {
            this._ngxSmartModalService
              .getModal("loopFillShowsPopupModal")
              .close();
          })
          .catch((err) => {
            this.errorMessage = err;
          })
          .finally(() => {
            this._processing = false;
          });
      } else {
        let targetEndTime = this.targetEndTime;
        if (this.selectedLoopType === LoopType.Multiplier) {
          targetEndTime = this._copyShowsViewModel.multiplySelectedEndTime(
            this.selectedMultiplier,
            this.targetStartTime,
          );
        }

        //const m = moment;
        console.log(
          "loop-fill-> apply clicked",
          targetEndTime,
          targetEndTime.clone().utc().format("HHmmssSSS"),
          this.targetStartTime,
          this.targetStartTime.clone().utc().format("HHmmssSSS"),
        );
        this._copyShowsViewModel
          .paste(
            this.targetStartTime,
            this.targetChannel,
            this.isBlock,
            targetEndTime,
          )
          .then(() => {
            this._processing = false;

            this._ngxSmartModalService
              .getModal("loopFillShowsPopupModal")
              .close();
          })
          .catch((err) => {
            this.errorMessage = err;

            this._processing = false;
          });
      }
    }
  }

  cancelDataPickerClicked(dt: CalendarDatepickerComponent) {
    dt.hide();
  }

  onDatepickerApply(time: moment.Moment) {
    const m = moment;
    this.targetEndTime = time
      .utc()
      .clone()
      .add(this._utcOffsetMins * -1, "minutes")
      .tz(this.targetChannelTimezone);
  }

  dtAfterInit(dt: CalendarDatepickerComponent) {
    this.targetEndTimeDatePicker = dt;
  }

  openDatePicker() {
    this.targetEndTimeDatePicker.show(this.targetEndTime);
  }
}

enum LoopType {
  UntilDate,
  Multiplier,
  UntilNextItem,
}

enum PasteType {
  Before,
  After,
}
